import { UserRole, type User } from './models';

export const canModifyUser = (user: User) => user.role.key !== UserRole.SystemAdmin;

export const canResendInvite = (user: User) => user.active && !user.verified;

export const canActivateUser = (user: User) => !user.active && canModifyUser(user);

export const canDeactivateUser = (user: User) => user.active && canModifyUser(user);
